module.exports = __webpack_public_path__ + "img/3.a8d8df2b.png";